import { gql, TypedDocumentNode } from "@apollo/client";

import { AwsIntegration, WorkerPool } from "types/generated";

type AttachableAwsIntegration = Pick<AwsIntegration, "id">;
type AttachableWorkerPool = Pick<WorkerPool, "id">;

type GetScanCreationRequirementsData = {
  awsIntegrations: AttachableAwsIntegration[];
  workerPools: AttachableWorkerPool[];
};

export const GET_SCAN_CREATION_REQUIREMENTS: TypedDocumentNode<GetScanCreationRequirementsData> = gql`
  query GetScanCreationRequirements {
    awsIntegrations(includeLegacy: false) {
      id
    }
    workerPools {
      id
    }
  }
`;
